import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Customer } from './../model/customer.model';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ApiService } from './../../app/services/api.service'
import { MatDialog} from '@angular/material/dialog';
import { CustomerDialog } from './../../app/dialogs/customer/customer.component';
import { CustomerBulkUploadDialog } from './../../app/dialogs/customer-bulk-upload/customer-bulk-upload.component';
import { BilldetailsDialog } from './../../app/dialogs/billdetails/billdetails.component';
import { DuebillsComponent } from './../../app/dialogs/duebills/duebills.component';
import { ImagepreviewComponent } from './../../app/dialogs/imagepreview/imagepreview.component';
import { QrcodeComponent } from '../dialogs/qrcode/qrcode.component';
import { AreaData } from '../model/area.model';
import { merge, Observable, of as observableOf, pipe } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {
  // private apiService: ApiService
  displayedColumns: string[] = ['customerId', 'customerName', 'customerPhone', 'areaName', 'customerAddress', 'customerUnitRate', 'customerDueAmount', 'customerStatus', 'custType', 'bill', 'qrcode', 'customerStatement', 'location', 'actions'];
  optionList = [
    { key: 1, name: 'Customer Id' },
    { key: 2, name: 'Customer Name' },
    { key: 3, name: 'Area Name' },
    { key: 4, name: 'Address' },
    { key: 5, name: 'Phone Number'}
  ];
  enableButton = false;
  isLoading = false;
  searchValue = '';
  totalData: number;
  selectedOption=0;
  pageSizes = [15, 30, 50];
  searchTriggered=false;
  dataSource = new MatTableDataSource<Customer>(null);
  customer: Customer = {
    areaCode: null,
    areaName: null,
    meterId: 0,
    previousReading:0 ,
    currentReading:0 ,
    latitude: null,
    longitude: null,
    customerId: 0,
    customerName: '',
    customerPhone: null,
    customerPhone2: null,
    customerPhone3: null,
    customerEmail: '',
    customerAddress: '',
    customerStatus: '',
    customerJoinedDate: '',
    customerUnitRate: 0,
    defaultUnitRate: 0,
    customerDueAmount: 0,
    custType: '',
    customerAction: 'add'
  }
  selectedCustomer: Customer;
  areas: AreaData[];
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(public dialog: MatDialog, private apiService: ApiService, private _snackBar: MatSnackBar, private changeDetectorRef: ChangeDetectorRef) {
    //this.getCustomerData();

  }
  customers: Customer[] = [];
  
  lat = 5.1521;
  lng = 46.1996;
  addressFromLatLng: string;
  ngOnInit(): void {
    
  }
  updateCustomerStatus(customerData: Customer) {
    /*if(customerData.customerDueAmount != 0){
      this._snackBar.open('Please clear the customer due amount', 'Close', {
        duration: 3000
      });
      return; 
    }*/
    if (customerData.customerStatus === 'Y') {
      customerData.customerStatus = 'N';
    } else if (customerData.customerStatus === 'N') {
      customerData.customerStatus = 'Y';
    }
   
    this.apiService.updateCustomer(customerData).subscribe(data => {
      if (data.isSuccess === true) {
        this._snackBar.open('Customer data updated successfully', 'Close', {
          duration: 3000
        });
      } else {
        this._snackBar.open('Error occured while updating details', 'Close', {
          duration: 3000
        });
      }
    });
  }

  deleteCustomer(): void {
    if(this.selectedCustomer.customerDueAmount != 0){
      this._snackBar.open('Please clear the customer due amount', 'Close', {
        duration: 3000
      });
      return;
    }
    this.apiService.deleteCustomer(this.selectedCustomer)
      .subscribe(data => {
        if (data.isSuccess) {
          this.getCustomerData();
          this._snackBar.open('Customer data deleted successfully', 'Close', {
            duration: 3000
          });
        }
      });
  }

  openCusUpdateDialog(customerData: Customer): void {
    customerData.customerAction = 'update';
    const dialogRef = this.dialog.open(CustomerDialog, {
      width: '900px',
      data: customerData
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openCusAddDialog(): void {

    // this.apiService.getTotalCustomersCount().subscribe(data => {
    //   this.customer.customerId = data.customerCount + 1;
    // });
    
    const dialogRef = this.dialog.open(CustomerDialog, {
      width: '900px',
      data: this.customer
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getCustomerData();
    });
  }

  openCusBulkUploadDialog(): void {
    const dialogRef = this.dialog.open(CustomerBulkUploadDialog, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getCustomerData();
      }
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openbillDialog(customerData: Customer): void {
    const dialogRef = this.dialog.open(BilldetailsDialog, {
      width: '800px',
      data: customerData
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  showMeterReading(customerData: Customer): void {
    const dialogRef = this.dialog.open(ImagepreviewComponent, {
      width: '600px',
      data: customerData
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  showQrCode(customerData: Customer){
    const dialogRef = this.dialog.open(QrcodeComponent, {
       width: '350px',
       data: customerData
     });
 
     dialogRef.afterClosed().subscribe(result => {
     });
   }

  openDueBillsDialog(customerData: Customer): void {
    customerData.customerAction = 'update';
    const dialogRef = this.dialog.open(DuebillsComponent, {
      width: '1200px',
      maxHeight: '80vh',
      data: customerData
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

   ngAfterViewInit() { 
    this.isLoading = true;
   this.apiService.getCustomers(
      0,
      15,
      this.selectedOption,
      this.searchValue
    )
.subscribe(empData => {
  //this.customers=empData;
  this.totalData = empData.totalItems;
  this.dataSource = new MatTableDataSource<Customer>(empData.customers);
  this.isLoading = false;
  this.changeDetectorRef.detectChanges();
});

   /* this.apiService.getCustomers(pageNumber, pageSize)
      .subscribe(data => {
        this.dataSource = new MatTableDataSource<Customer>(data.customers);
        const newCustomerId =  Math.max.apply(Math, data.customers.map(function(o : Customer) { return o.customerId; }));
        this.customer.customerId = newCustomerId + 1;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = (data:
          Customer, filterValue: string) =>
          (data.customerId.toString() == filterValue) ||
           (data.customerName ? data.customerName.trim().toLowerCase().indexOf(filterValue) !== -1 : false) ||
            (data.customerPhone ? data.customerPhone.toString().indexOf(filterValue) != -1 : false) ||
             (data.areaName ? data.areaName.trim().toLowerCase().indexOf(filterValue) !== -1 : false ) ;
      });*/
  }

  
  getAddressfromLatLng(){
    this.apiService.getAddressFromLatLng(this.selectedCustomer.latitude+','+this.selectedCustomer.longitude).subscribe(data => {
      this.addressFromLatLng = data.results[0].formatted_address;
    });
  }

  validateSearch(){
    if(this.searchValue.trim() != '' &&this.selectedOption!=1 && this.selectedOption!=0 && this.searchValue.trim().length >2){
      this.enableButton = true;
    }
    else if(this.searchValue.trim() != '' &&this.selectedOption==1 && this.searchValue.trim().length >0){
      this.enableButton = true;
    } else{
      this.enableButton = false;
    }
  }
  getCustomerData() { 
          this.isLoading = true;
          this.searchTriggered = true;
         this.apiService.getCustomers(
            0,
            15,
            this.selectedOption,
            this.searchValue
          )
      .subscribe(empData => {
        //this.customers=empData;
        this.totalData = empData.totalItems;
        this.dataSource = new MatTableDataSource<Customer>(empData.customers);
        this.isLoading = false;
        this.changeDetectorRef.detectChanges();
      });

}
nextpage(event:PageEvent){
  this.isLoading = true;
 if(this.searchTriggered){event.pageIndex=1;event.previousPageIndex=0};
 this.apiService.getCustomers(
  event.pageIndex,
  event.pageSize,
    this.selectedOption,
    this.searchValue
  )
.subscribe(empData => {
//this.customers=empData;
this.totalData = empData.totalItems;
this.dataSource = new MatTableDataSource<Customer>(empData.customers);
this.isLoading = false;
this.searchTriggered = false;
this.changeDetectorRef.detectChanges();
});

}
}
